import React, { Component } from 'react';
import queryString from 'query-string';
import DashboardBoxes from 'components/__old/common/dashboard-boxes';
// import Dropdown from "utils/dropdown";
import CurrencyFormat from "utils/currencyFormat";
import Pagination from 'components/__old/common/pagination';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { ReactComponent as IconNav } from "assets/images/icons/project-icons/Navicon-v.svg";
import { ReactComponent as IconUsers } from "assets/images/icons/project-icons/Users.svg";
import * as admin from "store/entities/settingsAdmin/action";
import * as walletAction from "store/entities/wallet/action";


// const dropdownTableIcon = <IconNav className="w-8 h-8 p-1.5 relative top-1 cursor-pointer group-hover:bg-gray-200 rounded" />;

class VirtualAccount extends Component {
    state = {
        getAllAdminParams: {
            page: 1,
            limit: 20,
            status: "",
            month: "February",
            year: "2021",
            download: false,
        },
        filter: {
            monthSelect: "",
            showMonthSelect: false,
        },
        dashboardProps1: {
            iconBg: "bg-blue-100",
            icon: <IconUsers className="customizeSVG text-blue-600 m-auto w-7 h-7" />,
            titleText: <span>Account Balance</span>,
            mainText: "-",
        },
        dashboardProps2: {
            iconBg: "bg-green-100",
            icon: <IconUsers className="customizeSVG text-green-600 m-auto w-7 h-7" />,
            titleText: <div className="w-full relative">Total Deposits <FontAwesomeIcon icon="caret-up" className="customizeSVG text-green-400 text-2xl absolute -top-1 right-0" /> </div>,
            mainText: "-",
        },
        dashboardProps3: {
            iconBg: "bg-red-100",
            icon: <IconUsers className="customizeSVG text-red-600 m-auto w-7 h-7" />,
            titleText: <div className="w-full relative">Total Withdrawals <FontAwesomeIcon icon="caret-down" className="customizeSVG text-red-400 text-2xl absolute -top-1 right-0" /> </div>,
            mainText: "-",
        },
        errors: {},
    }
    

    showMonthSelect = () => {
        const filter = {...this.state.filter, showMonthSelect: !this.state.filter.showMonthSelect};
        this.setState({filter});
    }


    toggleMonthSelect = (e) => {
        e.preventDefault();
        /*
        const {monthSelect} = this.state.filter;
        if (monthSelect !== ""){
            let d = new Date(monthSelect),
                month = '' + (d.getMonth() + 1),
                year = '' + d.getFullYear();
            month = MonthName(month);
            this.props.history.push("/withdrawals?month="+month+"&year="+year);
            
            const filter = {...this.state.filter, showMonthSelect: false};
            this.setState({filter});
        }
        */
    }


    getAllAdmin = () => {
        const qs = queryString.parse(this.props.location.search);
        let getAllAdminParams = {...this.state.getAllAdminParams};
        
        if ((qs.page !== undefined) && (!isNaN(qs.page)) && (qs.page > 0)){
            getAllAdminParams = {...getAllAdminParams, page: qs.page};
        }
        else{
            getAllAdminParams = {...getAllAdminParams, page: 1};
        }
        
        this.setState({getAllAdminParams});
        this.props.getAllAdmin(getAllAdminParams);
    }



    componentDidMount() {
        if (this.props.walletInfoLoading === false && this.props.walletInfo?.status !== "success"){
            this.props.getWalletDashboard(this.props.user?.token);
        }
        this.getAllAdmin();
    }
    

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.getAllAdmin();
        }
    }
    

    render() { 
        const { walletInfoLoading, walletInfo, allAdmin: data } = this.props;
        const { getAllAdminParams, filter, dashboardProps1, dashboardProps2, dashboardProps3 } = this.state;

        return ( 
            <div>
                
                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Transaction History
                        </div>
                    </div>
                </div>


                {(walletInfoLoading === true) && 
                    <div className="table-info">
                        <FontAwesomeIcon icon="circle-notch" spin />
                        <div className="font-bold uppercase">
                            Loading
                        </div>
                    </div>
                }

                {(walletInfoLoading === false) && (walletInfo?.status === undefined || walletInfo?.status === "failed") && 
                    <div className="table-info">
                        <FontAwesomeIcon icon="unlink" />
                        <div className="font-bold uppercase">
                            An error occurred
                            <br />
                            Please try again later.
                        </div>
                    </div>
                }

                {(walletInfoLoading === false) && (walletInfo?.status === "success") && 
                    <div className="mt-8 sm:flex sm:space-x-6 md:block md:space-x-0 lg:flex lg:space-x-6 space-y-6 sm:space-y-0 md:space-y-6 lg:space-y-0">
                        <div className="w-full sm:w-1/2 md:w-full lg:w-1/2 xl:w-2/3 box box-no-padding">

                            <div className="">
                                <div className="px-4 py-3 font-bold flex justify-between border-b border-opacity-40">
                                    <div className="my-auto">
                                        Account Overview
                                    </div>
                                    <div className="flex space-x-6">
                                        <div className="hidden my-auto xl:flex space-x-2">
                                            <div className="text-ep-secondary capitalize-first-letter">
                                                {walletInfo?.data?.walletDetails?.bankName}
                                            </div>
                                            <div style={{color:"#718096"}}>
                                                {walletInfo?.data?.walletDetails?.accountNumber}
                                            </div>
                                        </div>
                                        <div className="my-auto">
                                            <div onClick={this.showMonthSelect} className="btn btn-transparent-black btn-sm cursor-pointer">
                                                {getAllAdminParams.month}, {getAllAdminParams.year}
                                                <FontAwesomeIcon icon="caret-down" className="ml-2 text-lg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {(filter.showMonthSelect) &&
                                    <div className="w-full px-4 py-3 bg-gray-100">
                                        <form className="h-10 flex lg:justify-end" onSubmit={this.toggleMonthSelect}>
                                            <input type="month" name="monthSelect" value={filter.monthSelect} onChange={this.formChange} className="max-w-full w-full lg:w-auto h-full px-4 py-1 text-sm border border-gray-300 rounded rounded-r-none focus:outline-none focus:ring-2 focus:border-transparent" />
                                            <button type="submit" className="w-max h-full flex items-center justify-center font-bold space-x-2 px-6 py-2 btn-ep-primary rounded rounded-l-none focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-opacity-75">
                                                <FontAwesomeIcon icon="angle-right" className="text-2xl" />
                                            </button>
                                        </form>
                                    </div>
                                }

                                <div className="flex p-5 space-x-6">
                                    <div className="w-full 2xl:w-2/5">
                                        
                                        <div className="flex flex-col space-y-3">
                                            <DashboardBoxes data={dashboardProps1} result={CurrencyFormat(10000000)} />
                                            <DashboardBoxes data={dashboardProps2} result={CurrencyFormat(35000000)} />
                                            <DashboardBoxes data={dashboardProps3} result={CurrencyFormat(25000000)} />
                                        </div>  

                                    </div>
                                    <div className="w-1/2 2xl:w-3/5 hidden xl:block flex-shrink-0">
                                        <div className="w-full h-full bg-red-300">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="w-full sm:w-1/2 md:w-full lg:w-1/2 xl:w-1/3 box">

                            <div className="">
                                <div className="py-8 font-semibold">
                                    <div>
                                        To fund <span className="text-ep-primary">your Wallet</span>,
                                        <br />
                                        use the details below:
                                    </div>
                                    <div className="mt-8 flex flex-col space-y-8">
                                        <div>
                                            <div style={{color: "#425466"}}>
                                                Bank Name:
                                            </div>
                                            <div className="mt-1 text-black text-lg capitalize-first-letter">
                                                {walletInfo?.data?.walletDetails?.bankName}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{color: "#425466"}}>
                                                Account Number:
                                            </div>
                                            <div className="mt-1 text-black text-lg">
                                                {walletInfo?.data?.walletDetails?.accountNumber}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{color: "#425466"}}>
                                                Account Name:
                                            </div>
                                            <div className="mt-1 text-black text-lg">
                                                {walletInfo?.data?.walletDetails?.accountName}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }


                <div className="mt-8">
                    <div className="box box-no-padding">

                        <div className="w-full px-4 py-3 sm:py-0 sm:h-16 sm:flex">
                            <div className="w-full sm:w-1/2 uppercase font-bold my-auto">
                                All Transactions
                            </div>
                            <div className="w-full pt-2 sm:pt-0 sm:w-1/2 my-auto">
                                <div className="p-1 relative flex-shrink-0">
                                    
                                </div>
                            </div>
                        </div>

                        <div className="table-container">
                            <table className="table table-auto table-border">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Transaction Type</th>
                                        <th>Previous Balance</th>
                                        <th>Transaction Amount</th>
                                        <th>Current Balance</th>
                                        <th>Details</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(this.props.loading === true) && 
                                        <tr>
                                            <td colSpan="7">
                                                <div className="table-info">
                                                    <FontAwesomeIcon icon="circle-notch" spin />
                                                    <div className="font-bold uppercase">
                                                        Loading
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    
                                    {((this.props.loading === false) && (!data.docs)) && 
                                        <tr>
                                            <td colSpan="7">
                                                <div className="table-info">
                                                    <FontAwesomeIcon icon="unlink" />
                                                    <div className="font-bold uppercase">
                                                        An error occurred
                                                        <br />
                                                        Please try again later.
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    
                                    {((this.props.loading === false) && (data.docs) && (data.docs.length <= 0)) && 
                                        <tr>
                                            <td colSpan="7">
                                                
                                                {(data.page <= data.totalPages) &&
                                                    <div className="table-info">
                                                        <FontAwesomeIcon icon="list" />
                                                        <div className="font-bold uppercase">
                                                            No results found
                                                        </div>
                                                    </div>
                                                }
                                                
                                                {(data.page > data.totalPages) &&
                                                    <div className="table-info">
                                                        <FontAwesomeIcon icon="exclamation-triangle" />
                                                        <div className="font-bold uppercase">
                                                            Invalid Page Number
                                                        </div>
                                                        <div className="mt-2">
                                                            <Link to="?page=1" className="btn btn-ep-primary btn-sm mx-auto">Goto Page 1</Link>
                                                        </div>
                                                    </div>
                                                }

                                            </td>
                                        </tr>
                                    }


                                    {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                                        <>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-red-500 font-bold">
                                                        Withdrawal
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-red-500 font-bold">
                                                        - ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-red-500 font-bold">
                                                        Withdrawal
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-red-500 font-bold">
                                                        - ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-ep-primary font-bold">
                                                        29 Jan 2022
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        Deposit
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-green-500 font-bold">
                                                        + ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-bold">
                                                        ₦8,500,000
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        Lorem ipsum dolor sit amet
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="label label-green uppercase">
                                                        Completed
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    }



                                    {/* 
                                    {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                                        data.docs.map((admin, index) =>
                                        <tr key={index}>
                                            <td>
                                                <div className="text-ep-primary font-bold">
                                                    29 Jan 2022
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-green-500 font-bold">
                                                    Deposit
                                                </div>
                                            </td>
                                            <td>
                                                <div className="font-bold">
                                                    ₦8,500,000
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-green-500 font-bold">
                                                    + ₦8,500,000
                                                </div>
                                            </td>
                                            <td>
                                                <div className="font-bold">
                                                    ₦8,500,000
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    Lorem ipsum dolor sit amet
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label label-green uppercase">
                                                    Completed
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                     */}

                                </tbody>
                            </table>
                        </div>

                        {((this.props.loading === false) && (data.docs) && (data.docs.length > 0)) && 
                            <div>
                                <Pagination data={data} url={this.props.location.search} />
                            </div>
                        }

                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    walletInfoLoading: state.entities.wallet.dashboardLoading,
    walletInfo: state.entities.wallet.dashboard,
    loading: state.entities.settingsAdmin.loading,
    allAdmin: state.entities.settingsAdmin.allAdmin,
});

const mapDispatchToProps = (dispatch) => ({
    getWalletDashboard: (params) => dispatch(walletAction.getDashboardSilent(params)),
    getAllAdmin: (params) => dispatch(admin.getAllAdmin(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualAccount);
